module.exports = __webpack_public_path__ + "img/ms-icon-150x150.1f57355f.png";